// useApiMutation 的 undoable 成功 message 渲染 — JSX 在 .jsx 文件里,Vite 才能 transform
//
// useApiMutation.js 是 .js 文件不能放 JSX,所以这里单独抽出来一个 .jsx。

// 撤销 message 包装:在成功 message 上挂个"撤销"链接按钮
// 2026-10-17 P0-1 防御:撤销失败时不能只 swallow — 上层 mutation onError 早 destroy 了成功 toast,
// 用户看不到"刚创建的任务已存在"。这里显式给提示 + 保留成功 toast,告知状态。
// 2026-10-17 P0-2:`resourceHint` 可能返回对象(如「{name} 创建于 {time}」的 JSX),
// 直接拼到字符串里会退化为 "[object Object]"。统一走 `String(...)` 兜底;
// 同时 message.error 改成 options 形式 `{ content, duration }`,强制 6 秒钉住,
// 防止被 antd 默认 3 秒自动关掉,导致用户来不及读。
export function showUndoableSuccess(message, successMsg, undoConfig, data, variables) {
  const undoText = undoConfig?.undoText || '撤销'
  const onUndo = undoConfig?.onUndo
  if (typeof onUndo !== 'function') {
    // 没有 onUndo 退化为普通 success
    message.success(successMsg)
    return
  }
  // 资源名(尽量从 data / variables 抽),失败时给用户看"哪条没撤销成功"。
  // P0-2:resourceHint 可能是对象/JSX/数字/undefined,统一 String(...) 兜底,避免退化成
  // "[object Object]";若 caller 想展示 JSX,应在 hint 里就 String 化或包成 <span>{...}</span>。
  let resourceHint = ''
  if (typeof undoConfig?.resourceHint === 'function') {
    try {
      const raw = undoConfig.resourceHint(data, variables)
      resourceHint = raw == null ? '' : String(raw)
    } catch {
      resourceHint = ''
    }
  } else if (undoConfig?.resourceHint != null) {
    resourceHint = String(undoConfig.resourceHint)
  }
  const key = `undo-${Date.now()}-${Math.random().toString(36).slice(2, 8)}`
  message.open({
    key,
    duration: 5,
    type: 'success',
    content: (
      <span>
        {successMsg}{' '}
        <a
          style={{ marginLeft: 8, fontWeight: 500 }}
          onClick={async (e) => {
            e.preventDefault()
            try {
              await onUndo(data, variables)
              // 撤销成功才 destroy 成功 toast
              message.destroy(key)
            } catch (err) {
              // 撤销失败 — 显式提示,让用户知道资源没清掉,不能重复创建
              // P0-2:用 options 形式 { content, duration: 6 } 强制钉 6 秒 + 显式 content,
              // 避免 (resourceHint 是对象时) 字符串拼接退化为 "[object Object]"
              const tipContent = resourceHint
                ? `「${resourceHint}」撤销失败,请手动删除(创建已生效,可能与现有数据冲突)`
                : '撤销失败,请手动删除(创建已生效)'
              message.open({
                type: 'error',
                content: String(tipContent),
                duration: 6,
              })
              // 不 destroy 成功 toast — 让用户能看到"创建是成功的"
            }
          }}
        >
          {undoText}
        </a>
      </span>
    ),
  })
}